import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-filter-count',
  templateUrl: './filter-count.component.html',
})
export class FilterCountComponent {
  @Input() activeFiltersCount: number;
}
